/**
 * Put-wall gate label helpers. Ported verbatim from the Operator UI
 * (SkuBin.tsx:67-79, 105-116) so the scanner matches tasks to gates the same
 * way the desktop does.
 */

/** Strip the `PUT-` / `PUT ` prefix, leaving the bare gate id (e.g. "3"). */
export const normalizePutGate = (value?: string | null): string => {
  const raw = String(value ?? "").trim();
  if (!raw) {
    return "";
  }
  return raw.replace(/^put[\s-]*/i, "").trim();
};

/** Render a gate id back as the display label `PUT-<gate>`. */
export const formatPutGateLabel = (value?: string | null): string => {
  const gate = normalizePutGate(value);
  return gate ? `PUT-${gate}` : "";
};

/** Sort gates by their (numeric-aware) location. */
export const sortGatesByLocation = (
  left: { location?: string | null },
  right: { location?: string | null }
): number => {
  const leftGate = normalizePutGate(left.location);
  const rightGate = normalizePutGate(right.location);
  const leftNumber = Number(leftGate);
  const rightNumber = Number(rightGate);

  if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
    return leftNumber - rightNumber;
  }

  return leftGate.localeCompare(rightGate, undefined, { numeric: true });
};
